import moment from "moment"
import { Card, Col, Row } from "react-bootstrap"

function HistoricExpCLab({data, cita}){
    //console.log(cita)
    const {patientDTO} = cita

    return (
        data.length > 0 ?
        data.map((item, i)=>(
            <Card className="shadow-sm mb-3" key={i}>
                <Card.Body className="py-1">
                    <a href={item.url} target="_blank" rel="noreferrer" className="cursor-pointer">
                        <label className="font-weight-bold">{item.fileName}</label>
                    </a>
                    <div>
                        <label className="d-block mb-0">Subido por: </label>
                        {
                            item.uploadUser && item.uploadUser.name !== "PWA" ?
                            <ul className="list-unstyled">
                                <li><strong>Doctor: </strong> 
                                    {item.uploadUser.name}
                                </li>
                                <li><strong>Email:</strong> {item.uploadUser.email}</li>
                                <li className="text-secondary font-size-09rem">{moment(item.createDate, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")}</li>
                            </ul> :
                            <ul className="list-unstyled">
                                <li><strong>Paciente: </strong>{`${patientDTO.name} ${patientDTO.middleName ?? ''} ${patientDTO.lastName} ${patientDTO.seccondSurname ?? ''}`}</li>
                                <li><strong>Email:</strong> {patientDTO?.email}</li>
                                <li className="text-secondary font-size-09rem">{moment(item.createDate, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")}</li>
                            </ul>
                            
                        }
                    </div>
                </Card.Body>
            </Card>
        )) :
        <Row>
            <Col>No existe historial</Col>
        </Row>
    )
}

export default HistoricExpCLab